'use strict';

module.exports = {
  'USD': '$',
  'AUD': 'A$'
};